import React from 'react';
import './ContactUs.scss'
class ContactUs extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      bannerImages: [
        { imgPath: require("img/ContactUsbg.png"), imgHDPath: `${require("img/ContactUsbg.png")} 1x,${require("img/ContactUsbg@2x.png")} 2x,${require("img/ContactUsbg@3x.png")} 3x`, attachURL: "/" },
      ],
    }
  }
  componentDidMount() {

  }
  render() {
    return (
      <div className='ContactUs'>
        <main className="ContactUs-body">
          <section className="swiper-container">
            <div className="swiper-wrapper">
              {
                this.state.bannerImages.map((item, index) =>
                  item.attachURL && item.attachURL !== '/' ?
                    <a className="swiper-slide"
                      key={index}
                      href={item.attachURL}>
                      <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                    </a>
                    :
                    <img key={index} src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                )
              }
            </div>
            <div className="swiper-pagination"></div>
            <h5>联系我们</h5>
            <div className='ContactUs-table'>
              <div className='Cont-table-all'>
                <h4>青矩技术总部</h4>
                <table>
                  <tbody>
                    <tr>
                      <td>客服专线</td>
                      <td>
                        <a href="tel:400-607-8818" style={{ color: '#0A5992', textDecoration: 'underline' }}>400-607-8818</a>
                      </td>
                    </tr>
                    <tr>
                      <td>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
                      <td>北京市海淀区车公庄西路19号国际传播科技文化园9号楼</td>
                    </tr>
                    <tr>
                      <td>传&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;真</td>
                      <td>010-88018550</td>
                    </tr>
                    <tr>
                      <td>网&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
                      <td>www.greetec.com</td>
                    </tr>
                    <tr>
                      <td>电子邮箱</td>
                      <td>greetec@greetec.com</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='Cont-table-all Cont-table-server'>
                <h4>服务网络</h4>
                <div className='Cont-table-count'>
                  <p><i></i><span>华北大区</span></p>
                  <table>
                    <tbody>
                      <tr>
                        <td>北京<br />(总部)</td>
                        <td>
                          北京市海淀区车公庄西路19号国际传播科技文化园9号楼</td>
                      </tr>
                      <tr>
                        <td>天津</td>
                        <td>天津市和平区津塔写字楼69层</td>
                      </tr>
                      <tr>
                        <td>石家庄</td>
                        <td>石家庄市长安区中山东路39号勒泰中心B座2307-2308</td>
                      </tr>
                      <tr>
                        <td>张家口</td>
                        <td>河北省张家口市桥东区长江时代广场D座0330</td>
                      </tr>
                      <tr>
                        <td>山西</td>
                        <td>山西省太原市小店区君威国际金融中心A座1302</td>
                      </tr>
                      <tr>
                        <td>呼和浩特</td>
                        <td>内蒙古自治区呼和浩特市金川开发区世纪东街南嘉逸大厦南楼1706号</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='Cont-table-count'>
                  <p><i></i><span>东北大区</span></p>
                  <table>
                    <tbody>
                      <tr>
                        <td>沈阳</td>
                        <td>沈阳市和平区和平北大街156号光大大厦14层</td>
                      </tr>
                      <tr>
                        <td>大连</td>
                        <td>大连市沙河口区星海国际金融中心B座2602</td>
                      </tr>
                      <tr>
                        <td>哈尔滨</td>
                        <td>黑龙江省哈尔滨市南岗区嵩山路78号御景商座206室</td>
                      </tr>
                      <tr>
                        <td>长春</td>
                        <td>吉林省长春市朝阳区卫星路7440号远创国际A座 411室</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='Cont-table-count'>
                  <p><i></i><span>华中大区</span></p>
                  <table>
                    <tbody>
                      <tr>
                        <td>郑州</td>
                        <td>河南省郑州市中原区华山路220号芝麻街1958双创园D区16栋1-3层</td>
                      </tr>
                      <tr>
                        <td>武汉</td>
                        <td>武汉市江汉区建设大道568号新世界国贸大厦3402室</td>
                      </tr>
                      <tr>
                        <td>湖南</td>
                        <td>长沙市芙蓉区韶山北路208号维一星城国际27层</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='Cont-table-count'>
                  <p><i></i><span>华南大区</span></p>
                  <table>
                    <tbody>
                      <tr>
                        <td>广州</td>
                        <td>广东省广州市天河区水荫路115号天溢大厦A区501</td>
                      </tr>

                      <tr>
                        <td>深圳</td>
                        <td>广东省深圳市福田区福新社区鹏程一路9号广电金融中心16C</td>
                      </tr>
                      <tr>
                        <td>广西</td>
                        <td>广西省南宁市青秀区民族大道146号三祺广场1702A</td>
                      </tr>
                      <tr>
                        <td>海南</td>
                        <td>海南省海口市龙华区海秀中路71号海垦广场写字楼A座801室</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='Cont-table-count'>
                  <p><i></i><span>华东大区</span></p>
                  <table>
                    <tbody>
                      <tr>
                        <td>上海</td>
                        <td>上海市浦东新区世纪大道88号金茂大厦901室</td>
                      </tr>
                      <tr>
                        <td>江苏</td>
                        <td>南京市秦淮区中山南路1号南京中心大厦38层</td>
                      </tr>
                      <tr>
                        <td>杭州</td>
                        <td>浙江省杭州市江干区瑞晶国际商务中心3403室-1</td>
                      </tr>
                      <tr>
                        <td>安徽</td>
                        <td>合肥市包河区徽州大道838号平安国际金融中心1306-1307室</td>
                      </tr>
                      <tr>
                        <td>山东</td>
                        <td>济南市市中区胜利大街56号山东书城培训楼10层</td>
                      </tr>
                      <tr>
                        <td>苏州</td>
                        <td>中国（江苏）自由贸易试验区苏州片区苏州工业园区星海街198号星海大厦1幢第5层</td>
                      </tr>
                      <tr>
                        <td>福建</td>
                        <td>福建省福州市鼓楼区营迹路69号恒力创富中心908单元</td>
                      </tr>
                      <tr>
                        <td>江西</td>
                        <td>江西省南昌市红谷滩新区红谷中大道1402号浦发银行大厦6楼</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='Cont-table-count'>
                  <p><i></i><span>西北大区</span></p>
                  <table>
                    <tbody>
                      <tr>
                        <td>西安</td>
                        <td>陕西西安市高新区唐延路11号禾盛京广中心D座6层</td>
                      </tr>
                      <tr>
                        <td>甘肃</td>
                        <td>甘肃省兰州市七里河区西津西路16号兰州中心写字楼2903室</td>
                      </tr>
                      <tr>
                        <td>青海</td>
                        <td>西宁市城西区西川南路76号4号楼34层13407室</td>
                      </tr>
                      <tr>
                        <td>新疆</td>
                        <td>新疆乌鲁木齐天山区新华北路165号中信银行大厦22层</td>
                      </tr>
                      <tr>
                        <td>宁夏</td>
                        <td>宁夏银川市兴庆区凤凰北街天玺国际A座2808</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='Cont-table-count'>
                  <p><i></i><span>西南大区</span></p>
                  <table>
                    <tbody>
                      <tr>
                        <td>成都</td>
                        <td>四川省成都市锦江区龙舟路街道橡树林路189号瑞升国际中心26F</td>
                      </tr>
                      <tr>
                        <td>重庆</td>
                        <td>重庆市江北区庆云路1号国金中心T1栋20楼2-3号</td>
                      </tr>
                      <tr>
                        <td>云南</td>
                        <td>云南省昆明市五华区东风西路123号三合商利写字楼16层</td>
                      </tr>
                      <tr>
                        <td>贵州</td>
                        <td>贵阳市观山湖区金融城一期商务区11栋13楼</td>
                      </tr>
                      <tr>
                        <td>西藏</td>
                        <td>拉萨市柳梧新区浙商国际九栋</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='Cont-table-count'>
                  <p><i></i><span>雄安新区</span></p>
                  <table>
                    <tbody>
                      <tr>
                        <td>雄安</td>
                        <td>河北省保定市容城县上坡村上坡街202室</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    );
  }
}

export default ContactUs;
